export default defineAppConfig({
  ui: {
    primary: 'black',
    gray: 'neutral',
    notification: {
      background: 'bg-white',
      title: 'text-sm font-semibold text-black dark:text-white',
      description: 'mt-1 text-sm leading-4 dark:text-black text-black',
      shadow: 'shadow-sm',
      rounded: 'rounded-[20px]',
      padding: 'p-3 px-4',
      ring: 'ring-1 ring-gray-200',
      icon: {
        base: 'flex-shrink-0 w-8 h-8',
        color: 'text-black dark:text-black',
      },
      default: {
        closeButton: { icon: 'i-heroicons-x-mark', color: 'white', variant: 'solid', padded: true, size: '2xs', ui: { rounded: 'full' } }
      }
    },
    notifications: {
      // Show toasts at the top right of the screen
      position: 'top-0 bottom-auto  sm:ml-0 sm:left-[5rem] sm:top-auto sm:bottom-14',
      container: 'px-2 sm:px-6 py-4 space-y-3 overflow-y-auto',
    }
  }
})
